<template>
  <div class="container">
    <img
      src="@/assets/wardrobe.png"
      alt="Wardrobe"
      class="img img-responsive"
    />
  </div>
</template>

<script>
export default {
  name: "Wardrobe"
};
</script>
